import { createContext } from 'react';

import { User } from 'types';

export interface LoginData {
  login: string;
  password: string;
  newPassword?: string;
  data?: Record<string, unknown>;
}

export interface UserCtx {
  user: User;
  userId: string;
  login(data: LoginData): Promise<void>;
  logout(): void;
  isMe(id: string): boolean;
  changePassword(
    password: string,
    ConfirmationCode: string,
    Username: string,
    rethrow: boolean
  ): Promise<void>;
}

export const userContext = createContext<UserCtx>(null!);
